export default {
  total: '#e0e0e0',
  processed: '#fff9c4',
  processedPercents: '#fff9c4',
  accepted: '#c8e6c9',
  acceptedPercents: '#c8e6c9',
  acceptedSum: '#c8e6c9',
  canceled: '#ef9a9a',
  ProcessCancel: '#ef9a9a',
  canceledPercents: '#ef9a9a',
  error: '#f48fb1',
  ProcessSpam: '#f48fb1',
  errorPercents: '#f48fb1',
  return: '#ce93d8',
  returnPercents: '#ce93d8',
  paid: '#b9f6ca',
  cost_price: 'rgba(156,255,112,0.56)',
  paidPercents: '#b9f6ca',
  paidSum: '#b9f6ca',
  averageBill: '#90caf9',
  average_bill: '#90caf9',
  averageBillLocal: '#90caf9',
  averageBuyback: '#bae0ff',
  averageBuybackLocal: '#bae0ff',
  averageBillPopup: '#bae0ff',
  average_x_price: '#c8e6c9',
  payment_fix: '#e0e0e0',
  last_payment: '#90caf9',
  average_payment: '#fff9c4',
  proportion: '#fff9c4',
  approve: '#81c784',
  ProcessAccept: '#81c784',
  approved: '#81c784',
  orders_accepted: '#81c784',
  approvedFromValid: '#8fbc8f',
  points: '#e0e0e0',
  shipped: '#fff9c4',
  CancelAccept: '#fff9c4',
  SpamAccept: '#FFC107',
  transit: '#FFC107',
  transitPercents: '#FFC107',
  delivered: '#90caf9',
  buyout: '#b9f6ca',
  buyoutPercents: '#b9f6ca',
  additionalSale: '#dcedc8',
  oldBonus: '#e0e0e0',
  newBonus: '#e0e0e0',
  oldBonusHistory: '#f48fb1',
  newBonusHistory: '#c8e6c9',
  manager: '#FEE2D5',
  buyoutDelivered: '#b9f6ca',
  buyoutPaid: '#b9f6ca',
  AcceptCancel: '#90caf9',
  profit_for_oneminus: '#ef9a9a',
  profit_for_oneplus: '#c8e6c9',
  profit_for_periodminus: '#ef9a9a',
  profit_for_periodplus: '#c8e6c9',
  time_recall: '#fae5a4',
  time_success_call: '#c8cce6',
  count: '#90caf9',
  countPercents: '#90caf9',
  cancel_count: '#90caf9',
  month1: '#e0e0e0',
  month_persent_m1: '#e0e0e0',
  month2: '#c8e6c9',
  month_persent_m2: '#c8e6c9',
  month3: '#ef9a9a',
  month_persent_m3: '#ef9a9a',
  month4: '#f48fb1',
  month_persent_m4: '#f48fb1',
  month5: '#ce93d8',
  month_persent_m5: '#ce93d8',
  month6: '#b9f6ca',
  month_persent_m6: '#b9f6ca',
  month7: '#90caf9',
  month_persent_m7: '#90caf9',
  month8: '#FFC107',
  month_persent_m8: '#FFC107',
  month9: '#e0e0e0',
  month_persent_m9: '#FFC107',
  month10: '#b9f6ca',
  month_persent_m10: '#b9f6ca',
  month11: '#fff9c4',
  month_persent_m11: '#fff9c4',
  month12: '#ce93d8',
  month_persent_m12: '#ce93d8',
  adult: '#e0e0e0',
  slimming: '#fff9c4',
  beauty: '#c8e6c9',
  health: '#ef9a9a',
  economizers: '#ce93d8',
  lowPrice: '#b9f6ca',
  hair: '#90caf9',
  sport: '#fff9c4',
  other: '#FEE2D5',
  revenue_lead: '#fae5a4',
  deviation_mean: '#ef9a9a',
  dialer: '#ce93d8',
  average_first_call_time: '#ffd96a',
  average_number_touches: '#ffe083',
  average_calls: '#ffe69b',
  new_orders: '#e0e0e0',
  buyoutSum: '#b9f6ca',
  spam: '#f48fb1',
  call_duration: '#ffd96a',
  time_processing: '#ffe083',
  time_out_calls: '#ffe69b',
  holds: '#e0e0e0',
  active_operators: '#b9f6ca',
  expensive: '#ef9a9a',
  no_payment_method: '#ef9a9a',
  form_release: '#ef9a9a',
  want_guarantees: '#ef9a9a',
  not_processed: '#ef9a9a',
  expensive_delivery: '#ef9a9a',
  no_pay_tax: '#ef9a9a',
  changed_mind: '#ef9a9a',
  medical_contraindications: '#ef9a9a',
  not_allowed: '#ef9a9a',
  bad_reputation: '#ef9a9a',
  not_order: '#e0e0e0',
  not_delivery_time: '#e0e0e0',
  already_bought: '#e0e0e0',
  suite_different_price: '#e0e0e0',
  made_request: '#ef9a9a',
  no_nearby: '#e0e0e0',
  other_information: '#e0e0e0',
  won_gift: '#e0e0e0',
  language_barrier: '#e0e0e0',
  wrong_data: '#e0e0e0',
  drop_calls: '#e0e0e0',
  silent: '#e0e0e0',
  under_18: '#e0e0e0',
  not_ringing_long_time: '#e0e0e0',
  not_make_contact: '#e0e0e0',
  no_coverage: '#e0e0e0',
  blacklisted_customer: '#e0e0e0',
  minor: '#e0e0e0',
  another: '#e0e0e0',
  processed_all: '#fff9c4',
  total_cancel: '#ef9a9a',
  consultation: '#ef9a9a',
  any_reasons: '#e0e0e0',
  call_duration_approve: '#81c784',
  call_duration_cancel: '#ef9a9a',
  total_revenue: '#60b3f6',
  cross_sell_cost: '#60b3f6',
  cross_sell_local: '#60b3f6',
  operator: '#e0e0e0',
  parts_sms: '#e0e0e0',
  approvals: '#81c784',
  sent_sms: '#ffe69b',
  total_amount: '#90caf9',
  approve_percent: '#81c784',
  total_sms_sent: '#fff9c4',
  total_all: '#e0e0e0',
  total_lead_sms_sent: '#ffe69b',
  total_sms: '#ffe083',
  total_minutes: '#ffd96a',
  total_all_minutes: '#e0e0e0',
  total_minutes_lead: '#ffe69b',
  total_lead: '#ffe083',
  total_seconds_call: '#ffd96a'
}



// WEBPACK FOOTER //
// ./src/assets/TypeColor.js